import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import '../productPage/producthome.css';
import { Box } from '@mui/material';
import * as styles from '../productPage/tableComponents/ProductPage_style';
import { useLocation, useNavigate } from 'react-router-dom';
import BreadCrumbs from '../common/BreadCrumbs';
import { useLocale } from '../../contexts/LocaleProvider';
import YageoGroupOverviewPage from './YageoGroupOverviewPage';
import { useResponsive } from '../../contexts/ResponsiveContext';
import { getTabTypography } from '../investorPage/investorRelationHome';
import TabsComponent, { GetResponsiveWidth } from '../common/TabsComponent';

import { AboutYageoGroupOverviewContent } from '../../graphql/pimcore/modules/siteContent/types/AboutYageoGroupOverviewContent';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`product-tabpanel-${index}`}
            aria-labelledby={`product-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

interface YageoOverviewHomeProps {
    cmsContent: AboutYageoGroupOverviewContent;
}

const YageoGroupHome: FunctionComponent<YageoOverviewHomeProps> = ({ cmsContent }) => {
    const [url, setUrl] = useState(0);
    const location = useLocation();
    const [openMenu, setOpenMenu] = useState(false);
    const navigate = useNavigate();
    const { locale, messages } = useLocale();
    const { isScreenXxl, isScreenXl, isScreenLg, isScreenMd, isScreenSm, isScreenXs } =
        useResponsive();
    const tabTypography = getTabTypography(isScreenMd, isScreenSm);

    const pathMap = useMemo(
        () => ['/about/yageogroupoverview/', '/about/yageogroupoverview/ourhistory'],
        []
    );

    const Banner = {
        display: 'flex',
        flexDirection: 'column' as const,
        backgroundImage: `linear-gradient(rgba(183, 83, 50, 0.8), rgba(183, 83, 50, 0.8)), url(${cmsContent.pageTitleBackgroundImage.imageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        width: '100%',
        color: 'white',
    };

    const menuItems = [
        { label: cmsContent.Overview.title.content, value: 0 },
        // { label: 'Our History', value: 1 },
    ];

    useEffect(() => {
        const newValue = pathMap.indexOf(location.pathname);
        setUrl(newValue >= 0 ? newValue : 0);
    }, [location.pathname, pathMap]);

    const handleChange = (event: React.SyntheticEvent<Element, Event> | null, newValue: number) => {
        setUrl(newValue);
        const path = pathMap[newValue] ?? pathMap[0];
        if (path) {
            navigate(path);
        }
    };

    return (
        <div key={location.pathname} style={styles.productPageContainer}>
            <div style={styles.breadCrumbs}>
                <Box
                    sx={{
                        width: GetResponsiveWidth,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        margin: 'auto',
                    }}
                >
                    <BreadCrumbs navigationPath="/Home/About/YageoGroupOverview" />
                </Box>
            </div>
            <div style={Banner}>
                <Box
                    sx={{
                        width: GetResponsiveWidth,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        margin: 'auto',
                        height: '180px',
                    }}
                >
                    <span
                        style={{
                            ...styles.bannerFont,
                            fontSize: isScreenXs ? '22px' : styles.bannerFont.fontSize,
                            marginBottom: isScreenXs ? '6px' : styles.bannerFont.marginBottom,
                        }}
                    >
                        {cmsContent.pageTitle.content}
                    </span>
                    <span
                        style={{
                            ...styles.bannerFont2,
                            fontSize: isScreenXs ? '14px' : styles.bannerFont2.fontSize,
                            marginBottom: '2px',
                        }}
                    >
                        {cmsContent.pageSubtitle.content}
                    </span>
                </Box>
            </div>
            <Box sx={{ width: '100%', backgroundColor: '#7A7C81' }} data-testid={'outter_box'}>
                <TabsComponent
                    url={url}
                    setOpenMenu={setOpenMenu}
                    openMenu={openMenu}
                    handleChange={handleChange}
                    menuItems={menuItems}
                    tabTypography={tabTypography}
                    isMenuExpandMoreIcon
                />
                <CustomTabPanel value={url} index={0}>
                    <YageoGroupOverviewPage cmsContent={cmsContent.Overview} />
                </CustomTabPanel>
                {/*<CustomTabPanel value={url} index={1}>*/}
                {/*    <Box*/}
                {/*        sx={{*/}
                {/*            display: 'flex',*/}
                {/*            justifyContent: 'center',*/}
                {/*            padding: '0',*/}
                {/*            width: '100%',*/}
                {/*            boxSizing: 'border-box',*/}
                {/*            flexDirection: 'column',*/}
                {/*            overflowY: 'hidden',*/}
                {/*            backgroundColor: 'white',*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        <Box*/}
                {/*            sx={{*/}
                {/*                display: 'flex',*/}
                {/*                justifyContent: 'space-between',*/}
                {/*                paddingTop: '1.5rem',*/}
                {/*                paddingBottom: '1.5rem',*/}
                {/*                flexDirection: 'column',*/}
                {/*                overflowY: 'hidden',*/}
                {/*                width: GetResponsiveWidth,*/}
                {/*                alignItems: 'flex-start',*/}
                {/*                margin: 'auto',*/}
                {/*            }}*/}
                {/*        >*/}
                {/*            Coming Soon*/}
                {/*        </Box>*/}
                {/*    </Box>*/}
                {/*</CustomTabPanel>*/}
                {/*<CustomTabPanel value={url} index={2}>*/}
                {/*    <ToolPage />*/}
                {/*</CustomTabPanel>*/}
            </Box>
        </div>
    );
};

export default YageoGroupHome;
